import script from "./SettingCompT.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingCompT.vue?vue&type=script&setup=true&lang=js"

import "./SettingCompT.vue?vue&type=style&index=0&id=78744bd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78744bd6"]])

export default __exports__